import { render, staticRenderFns } from "./CollectivesIcon.vue?vue&type=template&id=dc7ddfee"
import script from "./CollectivesIcon.vue?vue&type=script&lang=js"
export * from "./CollectivesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports